import { MARKS } from '@contentful/rich-text-types'
const { BOLD, ITALIC, UNDERLINE, CODE } = MARKS

export default {
  [BOLD]: (text, key, h) => h('strong', { key }, text),
  [ITALIC]: (text, key, h) => h('em', { key }, text),
  [UNDERLINE]: (text, key, h) => h('u', { key }, text),
  [CODE]: (text, key, h) => h('code', { key }, text),
}
